import React, { useState } from 'react';
import { Bell } from 'lucide-react';

const NotificationBell = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [notifications] = useState([
    {
      id: 1,
      title: '🎉 New Feature: A/B Testing',
      message: 'Create A/B test campaigns to compare performance',
      date: '2026-03-30',
      read: false
    },
    {
      id: 2,
      title: '✨ Enhanced Metrics',
      message: 'Admin can now upload campaign metrics via CSV or manual entry',
      date: '2026-03-29',
      read: false
    },
    {
      id: 3,
      title: '📊 Drive Link Support',
      message: 'Share Google Drive links for creative assets',
      date: '2026-03-28',
      read: true
    }
  ]);

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="relative">
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="relative h-10 w-10 rounded-full flex items-center justify-center hover:bg-slate-100 transition-colors"
        title="Notifications"
        data-testid="notification-bell-button"
      >
        <Bell size={20} className="text-slate-400" style={{ color: '#32B4AC' }} />
        {unreadCount > 0 && (
          <span 
            className="absolute top-1 right-1 w-2 h-2 rounded-full"
            style={{ backgroundColor: '#32B4AC' }}
          />
        )}
      </button>

      {showDropdown && (
        <>
          {/* Overlay to close dropdown */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setShowDropdown(false)}
          />

          {/* Dropdown panel */}
          <div 
            className="absolute right-0 mt-2 w-80 bg-slate-800 border border-slate-700 rounded-xl shadow-xl z-20 overflow-hidden"
          >
            <div className="p-4 border-b border-slate-700">
              <h3 className="text-sm font-semibold text-white">
                🔔 Feature Updates
              </h3>
              {unreadCount > 0 && (
                <span className="text-xs" style={{ color: '#32B4AC' }}>
                  {unreadCount} new update{unreadCount > 1 ? 's' : ''}
                </span>
              )}
            </div>

            <div className="max-h-96 overflow-y-auto">
              {notifications.map((notif) => (
                <div
                  key={notif.id}
                  className={`p-4 border-b border-slate-700 hover:bg-slate-750 transition-colors ${
                    !notif.read ? 'bg-slate-750/50' : ''
                  }`}
                >
                  <div className="flex items-start gap-2">
                    {!notif.read && (
                      <div 
                        className="w-2 h-2 rounded-full mt-1.5 flex-shrink-0"
                        style={{ backgroundColor: '#32B4AC' }}
                      />
                    )}
                    <div className="flex-1">
                      <p className="text-sm font-medium text-white mb-1">
                        {notif.title}
                      </p>
                      <p className="text-xs text-slate-400 mb-1">
                        {notif.message}
                      </p>
                      <p className="text-xs text-slate-500">
                        {new Date(notif.date).toLocaleDateString('en-US', {
                          month: 'short',
                          day: 'numeric',
                          year: 'numeric'
                        })}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {notifications.length === 0 && (
              <div className="p-8 text-center">
                <p className="text-sm text-slate-400">No new updates</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationBell;
